import { useMemo } from 'react';
import { usePortalQuery, EHttpMethod } from './usePortalQuery';
import { UserInfo, UserInfoResponse } from '@portal_components/types';
import { EnvironmentVariables } from '../EnvironmentVariables';

export const useUserInfo = (): { isUserInfoLoading: boolean; userInfo: UserInfo | undefined } => {
  const { data: userInfoResponse, isLoading } = usePortalQuery<UserInfoResponse>(
    EHttpMethod.GET,
    'user-info',
    'get-user-info',
    true,
    undefined,
    undefined,
    undefined,
    false,
    600000,
    600000
  );

  const userInfo: UserInfo | undefined = useMemo(() => {
    if (!userInfoResponse) return undefined;
    const { permissions, ...rest } = userInfoResponse;
    if (!permissions) return undefined;
    const application = EnvironmentVariables.UpumApplicationName;
    const role = permissions[application];
    if (!role) return undefined;
    return { ...rest, role } as unknown as UserInfo;
  }, [userInfoResponse]);

  return { isUserInfoLoading: isLoading, userInfo };
};
